import { useStore } from '@/providers/app-store-provider';
import { usePathname } from 'next/navigation';
import { useLayoutEffect, useRef } from 'react';
import { readAuthTokenFromCookie } from '@/utils/tools';
export default function useSyncToken() {
  const setToken = useStore((state) => state.setToken);
  const setClientTokenReady = useStore((state) => state.setClientTokenReady);
  const pathname = usePathname();
  /** 与 pathname 同步轮次对齐，避免 Strict / 快速连跳时过期微任务把 clientTokenReady 留在 false */
  const tokenSyncCommitRef = useRef(0);

  // 用户信息与 token：路由变化时先标记未就绪，再从 cookie 同步后标记就绪
  useLayoutEffect(() => {
    setClientTokenReady(false);
    const commit = ++tokenSyncCommitRef.current;
    queueMicrotask(() => {
      if (commit !== tokenSyncCommitRef.current) return;
      const tokenFromCookie = readAuthTokenFromCookie();
      if (tokenFromCookie) {
        setToken(tokenFromCookie);
      }
      setClientTokenReady(true);
    });
  }, [pathname, setToken, setClientTokenReady]);
}
